<template><div class="ai-component-body">
        <h3>{{ card.title }}</h3>
        <p v-if="card.contextText" class="ai-impact">{{ card.contextText }}</p>
        <div class="ai-device-group" :class="{ 'is-scrolled': hasDeviceScrolled }" :style="{ '--device-columns': deviceColumns }">
          <ai-list-surface :scrolled="hasDeviceScrolled">
          <div ref="deviceScroll" class="ai-device-scroll ai-list-scroll" :class="{ 'is-scrollable': hasDeviceOverflow }" tabindex="0" role="region" aria-label="设备列表，可上下滚动" @scroll.passive="measureDeviceOverflow(); loadDevicesOnScroll()">
            <div ref="deviceGrid" class="ai-manual-grid"><div v-for="item in card.items" :key="[item.ref.regionId,item.ref.productId,item.ref.deviceId].join('|')" class="ai-device-frame"><ai-manual-device :item="item" :busy="disabled" /></div></div>
            <p v-if="!card.items.length" class="ai-device-empty">{{ card.emptyText }}</p>
          </div>
          </ai-list-surface>
          <footer class="ai-device-footer ai-list-footer">
            <span>{{ card.footerText }}</span>
            <span v-if="pagination.loading" class="ai-device-more-hint" role="status">加载中…</span>
            <button v-else-if="pagination.error" class="ai-load-devices" :disabled="busy" @click="requestDevicePage(true)">加载失败，点击重试</button>
            <span v-else-if="card.hasMore && hasDeviceOverflow" class="ai-device-more-hint">向下滚动加载更多</span>
            <button v-else-if="card.hasMore" class="ai-load-devices" :disabled="busy" @click="requestDevicePage(true)">加载更多</button>
          </footer>
        </div>
        <ai-notice v-if="card.notice" :message="card.notice" />
      </div></template>
<script>
import scrollbarBehavior from '@/ai/components/mixins/scrollbar-behavior'
import behavior from '@/ai/components/mixins/device-behavior'
import AiListSurface from './AiListSurface.vue'
export default { components: { AiListSurface }, mixins: [behavior, scrollbarBehavior] }
</script>
<style scoped src="./cards.css"></style>
<style scoped src="./surfaces.css"></style>
<style scoped>
/* 布局与模板同文件维护。根节点必须有布局盒，ResizeObserver才能测量真实宽度。 */
.ai-component-body { display: block; min-width: 0; width: 100%; }
.ai-device-group { width:100%;min-width:0; }
.ai-device-scroll { max-height:248px; }
.ai-manual-grid { display: grid; grid-template-columns: repeat(var(--device-columns, 1), minmax(0, 180px)); gap: 10px; }
.ai-manual-grid > * { min-width: 0; }
/* AI外包装仅承载网格，不附加描边或阴影，保留原卡片边缘和弹窗定位。 */
.ai-device-frame { border-radius: 14px;  }
.ai-load-devices { border: 0; padding: 0; background: transparent; color: #174b91; font: inherit; cursor: pointer; }
.ai-device-empty { margin: 8px 0; color: #293e5b; font-size: 12px; }
</style>
